import PlanActionTypes from './types';

export const fetchConsignerPlanDetailsStart = (payload: any) => ({
  type: PlanActionTypes.FETCH_CONSIGNER_PLAN_DETAILS_START,
  payload,
});

export const fetchConsignerPlanDetailsSuccess = (payload: any) => ({
  type: PlanActionTypes.FETCH_CONSIGNER_PLAN_DETAILS_SUCCESS,
  payload,
});

export const fetchConsignerPlanDetailsFailure = (payload: any) => ({
  type: PlanActionTypes.FETCH_CONSIGNER_PLAN_DETAILS_FAILURE,
  payload,
});

export const initiateConsignerPlanPaymentStart = (payload: any) => ({
  type: PlanActionTypes.INITIATE_CONSIGNER_PLAN_PAYMENT_START,
  payload,
});

export const initiateConsignerPlanPaymentSuccess = (payload: any) => ({
  type: PlanActionTypes.INITIATE_CONSIGNER_PLAN_PAYMENT_SUCCESS,
  payload,
});

export const initiateConsignerPlanPaymentFailure = (payload: any) => ({
  type: PlanActionTypes.INITIATE_CONSIGNER_PLAN_PAYMENT_FAILURE,
  payload,
});

export const initiateConsignerPlanPaymentStatusStart = (payload: any) => ({
  type: PlanActionTypes.INITIATE_CONSIGNER_PLAN_PAYMENT_STATUS_START,
  payload,
});

export const initiateConsignerPlanPaymentStatusSuccess = (payload: any) => ({
  type: PlanActionTypes.INITIATE_CONSIGNER_PLAN_PAYMENT_STATUS_SUCCESS,
  payload,
});

export const initiateConsignerPlanPaymentStatusFailure = (payload: any) => ({
  type: PlanActionTypes.INITIATE_CONSIGNER_PLAN_PAYMENT_STATUS_FAILURE,
  payload,
});
